import React from "react";
import { Periods, RideStatusLabels } from "../../helpers/enums";
import { controlStyle } from "../../helpers/constants";
import { general } from "../../locales/general";
import DateFilters from "../ui/DateFilters";
import Pagination from "../ui/Pagination";
import RenderTable from "../ui/RenderTable";
import SimpleUserRidersTable from "./tables/UserRides";
import { Chip } from "../../helpers/general";
import { cardStyle } from "../../pages/Places/PlacesTable";

interface Props {
  rideFilters: any;
  setRideFilters: (filters: any) => void;
  isLoading: boolean;
  rides: any;
  handleRidePageChange: (page: number) => void;
  setDates: (dates: any) => void;
  defaultPeriod?: Periods;
}

export const RidesTab: React.FC<Props> = ({
  rideFilters,
  setRideFilters,
  isLoading,
  rides,
  handleRidePageChange,
  setDates,
  defaultPeriod,
}) => {
  const items: any[] = rides?.items ?? [];
  const total = rides?.meta?.totalItems ?? 0;
  const totalPages = rides?.meta?.totalPages ?? 0;

  return (
    <div>
      {/* Title + count */}
      <div className="d-flex align-items-center gap-2 mb-3 ms-4">
        <h5 className="fs-5 fw-bold mb-0">Trajets</h5>
        {rides?.meta && (
          <Chip tone="warning">
            {total} {total > 1 ? "trajets" : "trajet"}
          </Chip>
        )}
      </div>

      {/* Filters */}
      <div
        style={{ ...cardStyle, padding: "14px 16px" }}
        className="d-flex flex-wrap align-items-end gap-3 mb-3"
      >
        <div className="d-flex flex-column gap-1">
          <label
            htmlFor="status"
            className="text-muted mb-0"
            style={{ fontSize: 11 }}
          >
            Statut
          </label>
          <select
            id="status"
            className="form-select px-3"
            style={{ ...controlStyle, width: "auto", minWidth: 160 }}
            value={rideFilters.status}
            onChange={(e) =>
              setRideFilters((prev: any) => ({
                ...prev,
                status: e.target.value,
                page: 1,
              }))
            }
          >
            <option value="">Tous</option>
            {Object.entries(RideStatusLabels).map(([key, label]) => (
              <option key={key} value={key}>
                {String(label)}
              </option>
            ))}
          </select>
        </div>

        <DateFilters
          label="Date"
          onChange={setDates}
          defaultPeriod={defaultPeriod}
        />
      </div>

      {/* Table */}
      <div style={{ ...cardStyle, padding: 0, overflow: "hidden" }}>
        <RenderTable
          loading={isLoading && items.length === 0}
          render={() =>
            items.length > 0 ? (
              <SimpleUserRidersTable rides={items} />
            ) : (
              <p className="text-center text-muted py-5 mb-0">
                {general.fr.noData}
              </p>
            )
          }
        />
      </div>

      <Pagination
        currentPage={rideFilters.page}
        onPageChange={handleRidePageChange}
        totalCount={totalPages}
        pageSize={rideFilters.limit}
        siblingCount={1}
      />
    </div>
  );
};
